import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import moment from 'moment';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { Text } from 'recharts';
import Drawer from '@material-ui/core/Drawer';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { Modal, TableRow } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import NotifyPopupShop from '../../components/molecules/NotifyPopupShop';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import {
  getPaymentSummary,
  sendMailPaymentDetailMonth,
  getGochiTipSummary,
  getGochiTipUrl
} from '../../actions/Shop';
import MenuBox from '../../components/MenuBox';
import {
  DOWNLOAD_PDF_INVOICE_SUCCESS,
  downloadPdfInvoice
} from '../../actions/Invoices';

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    // backgroundColor: 'rgba(0, 0, 0, .03)',
    // borderBottom: '1px solid rgba(0, 0, 0, .125)',
    border: 0,
    marginBottom: -1,
    padding: '0 10px',
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0
  }
})(MuiAccordionDetails);

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 20,
    textAlign: 'left',
    backgroundColor: '#F7F7F7'
  },
  pageTitileDiv2: {
    textAlign: 'left'
  },
  mainWrapper: {
    padding: '17px 20px 0 20px',
    marginBottom: 40
  },
  mainPaper1: {
    position: 'relative',
    backgroundColor: '#2196F3'
  },
  mainPaper: {
    position: 'relative',
    marginBottom: 20
  },
  payslipDiv: {
    padding: '30px 14px 15px 14px',
    textAlign: 'center'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: '28px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textTitle2: {
    marginTop: 20,
    marginBottom: 20,
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: '23px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  textMonthHighlight: {
    textAlign: 'left'
  },
  textCurrentReceivedMoneyDiv: {
    textAlign: 'center',
    padding: '20px 0'
  },
  textCurrentReceivedMoney: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 15
  },
  textNum: {
    fontSize: 50,
    fontWeight: 'bold',
    color: '#fff',
    lineHeight: '66px'
  },
  textNumBlack: {
    fontSize: 50,
    fontWeight: 'bold',
    lineHeight: '66px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textCurrency: {
    fontSize: 30,
    fontWeight: 'bold',
    lineHeight: '39px',
    color: '#fff'
  },
  textCurrencyBlack: {
    fontSize: 30,
    fontWeight: 'bold',
    lineHeight: '39px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textIntendedReceiveMoneyDiv: {
    margin: '10px 20px 0 20px',
    backgroundColor: '#fff',
    padding: '18px 20px',
    alignItems: 'center'
  },
  textIntendedReceiveMoney: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '16px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textMoneyDiv: {
    marginLeft: 'auto'
  },
  textSmallNum: {
    fontSize: 26,
    fontWeight: 'normal',
    lineHeight: '32px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textSmallCurrency: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  currentDateDiv: {
    textAlign: 'right',
    marginTop: 12,
    marginBottom: 15
  },
  currentDate: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  horizotalLine: {
    borderBottom: '1px solid #DBDBDB'
  },
  textTitleNotify: {
    textAlign: 'left',
    marginTop: 18,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '19px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textNotify: {
    textAlign: 'left',
    marginTop: 18,
    marginBottom: 20,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textHeading: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '24px',
    marginLeft: 5,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  blackColor: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  button: {
    width: '100%',
    marginTop: 10
  },
  textNoteDiv: {
    marginTop: 11
  },
  textNote: {
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  stripeLink: {
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '16px'
  },
  viewStripeLinkDiv: {
    backgroundColor: '#F7F7F7',
    textAlign: 'right',
    paddingRight: 20
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoCellHeader: {
    padding: '2px 10px',
    width: '180px',
    // maxWidth: '150px',
    border: '1px solid #ddd',
    fontSize: '12px',
    // fontWeight: 'bold',
    color: '#000000',
    // backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    padding: '2px 10px',
    // borderBottom: '2px solid transparent',
    border: '1px solid #ddd',
    fontSize: '12px',
    whiteSpace: 'break-spaces',
    textAlign: 'right'
  },
  tableCellBorderNone: {
    border: 'none'
  },
  alignRight: {
    textAlign: 'right'
  },
  bankTransferNoteDiv: {
    textAlign: 'left'
  },
  supportLinkDiv: {
    textAlign: 'left'
    // marginBottom: 10
  },
  supportLink: {
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '24px'
  },
  btnViewMore: {
    textAlign: 'center',
    marginBottom: 30
  },
  collapseBtn: {
    backgroundColor: 'transparent',
    flexDirection: 'row-reverse',
    padding: 0,
    marginLeft: '-12px',
    borderBottom: 'none'
  },
  arrowCustom: {
    backgroundColor: '#2196F3',
    color: '#ffffff',
    width: 15,
    height: 15,
    borderRadius: '50%',
    margin: 0
  },
  textExplainDate: {
    color: '#ffffff',
    fontSize: 12,
    margin: '10px 20px 0',
    textAlign: 'left'
  },
  fs20: {
    fontSize: 20
  },
  paymentBalanceDiv: {
    backgroundColor: '#ffffff',
    border: '4px solid #2196F3',
    borderRadius: 2,
    color: '#2196F3',
    fontWeight: 700,
    marginTop: 24,
    padding: '24px 16px',
    textAlign: 'center'
  },
  donateGochiKidInfo: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  donateGochiKidDiv: {
    margin: '10px 30px 0'
  },
  donateGochiKidIcon: {
    width: 9,
    height: 10,
    marginLeft: 5
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getPaymentSummary,
          sendMailPaymentDetailMonth,
          getGochiTipSummary,
          getGochiTipUrl,
          downloadPdfInvoice
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('openNotifyPopup', 'setOpenNotifyPopup', false),
  withState('textTitle', 'setTextTitle', ''),
  withState('textMessage', 'setTextMessage', ''),
  withState('resultMessage', 'setResultMessage', ''),
  withState('page', 'setPage', 1),
  withState('listPayments', 'setListPayments', []),
  withState('sumAmountCurrentMonth', 'setSumAmountCurrentMonth', 0),
  withState('sumAmountLastMonth', 'setSumAmountLastMonth', 0),
  withState('currentMonth', 'setCurrentMonth', null),
  withState('nextMonth', 'setNextMonth', null),
  withState('shopStripeFlag', 'setShopStripeFlag', 0),
  withState('hasMore', 'setHasMore', true),
  withState('nextHref', 'setNextHref', 1),
  withState('paymentBalance', 'setPaymentBalance', 0),
  withState('sumAmountGochiKidDonate', 'setSumAmountGochiKidDonate', 0),
  withState('sumAmountGochiKidCanUse', 'setSumAmountGochiKidCanUse', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      setTimeout(() => {
        const searchKey = {
          page,
          limit
        };

        props.updateLoading(true);
        props.updateOpenProgress(true);
        props.actions
          .getPaymentSummary(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            let list = [];
            if (page > 1) {
              list = props.listPayments;
            } else {
              list = [];
              props.setNextHref(1);
            }

            if (data.type === 'GET_PAYMENT_SUMMARY_SHOP_SUCCESS') {
              if (data.payload.list) {
                data.payload.list.map(payment => {
                  return list.push(payment);
                });
                props.setListPayments(list);
                if (data.payload.offset + 5 < data.payload.count) {
                  props.setHasMore(true);
                } else {
                  props.setHasMore(false);
                }
              }
              props.setSumAmountCurrentMonth(
                data.payload.shopStripeFlag === 1
                  ? data.payload.sumAmountStripeCurrentMonth
                  : data.payload.sumAmountBillCurrentMonth
              );
              props.setSumAmountLastMonth(
                data.payload.sumAmountBillLastMonth +
                  data.payload.sumAmountStripeLastMonth
              );
              props.setCurrentMonth(data.payload.currentMonthStr);
              props.setNextMonth(data.payload.nextMonthStr);
              props.setShopStripeFlag(data.payload.shopStripeFlag);
              props.setPaymentBalance(data.payload.paymentBalance || 0);
              props.setSumAmountGochiKidDonate(
                data.payload.sumAmountGochiKidDonate || 0
              );
              props.setSumAmountGochiKidCanUse(
                data.payload.sumAmountGochiKidCanUse || 0
              );
            }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            console.log(error);
          });
      }, 100);
    },
    handleGetGochiTipUrl: props => () => {
      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getGochiTipUrl()
        .then(data => {
          if (data.type === 'GET_GOCHI_TIP_URL_SUCCESS') {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            if (data.payload.url) {
              window.open(data.payload.url, '_blank');
            }
          } else if (data.type === 'GET_GOCHI_TIP_URL_FAILURE') {
            props.updateLoading(false);
            props.setResultMessage(
              'エラーが発生しました。もう一度やり直してください。'
            );
          }
        })
        .catch(error => {
          props.updateLoading(false);
          props.setResultMessage(
            'エラーが発生しました。もう一度やり直してください。'
          );
          console.log(error);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.handleChangePage(null, 1, 5);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    textTitle,
    setTextTitle,
    textMessage,
    setTextMessage,
    openNotifyPopup,
    setOpenNotifyPopup,
    openProgress,
    updateOpenProgress,
    loading,
    updateLoading,
    resultMessage,
    currentMonth,
    nextHref,
    setNextHref,
    hasMore,
    listPayments,
    sumAmountCurrentMonth,
    sumAmountLastMonth,
    handleRedirect,
    handleChangePage,
    nextMonth,
    shopStripeFlag,
    paymentBalance,
    sumAmountGochiKidDonate,
    sumAmountGochiKidCanUse
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }
    // const backAction = () => handleRedirect('/release_step');

    const loadMoreMenus = async () => {
      setNextHref(nextHref + 1);
      handleChangePage(null, nextHref + 1, 5);
    };

    const onClickAction = async params => {
      updateLoading(true);
      updateOpenProgress(true);
      console.log('Goi api gui mail', params);
      const result = await actions
        .sendMailPaymentDetailMonth(params)
        .then(data => checkSession(data));
      if (result.type === 'SEND_MAIL_PAYMENT_DETAIL_MONTH_SUCCESS') {
        setTextTitle('メール送信完了');
        setTextMessage(
          isFukuoka
            ? '精算詳細のメールを送りました。'
            : '入金詳細のメールを送りました。'
        );
        updateLoading(false);
        updateOpenProgress(false);
        setOpenNotifyPopup(true);
      } else {
        setTextTitle('メール送信エラー');
        setTextMessage(
          isFukuoka
            ? '精算詳細のメールが送れません。もう一度お試しください。'
            : '入金詳細のメールが送れません。もう一度お試しください。'
        );
        updateLoading(false);
        updateOpenProgress(false);
        setOpenNotifyPopup(true);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const currencyFormat = num => {
      if (!num) {
        return 0;
      }
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    const monthFormat = timeStr => {
      if (!timeStr) {
        return 0;
      }
      let date = new Date(timeStr);
      if (Number.isNaN(date.getMonth())) {
        const arr = timeStr.split(/[- :]/);
        const dateTmp = new Date(
          arr[0],
          arr[1] - 1,
          arr[2],
          arr[3],
          arr[4],
          arr[5]
        );
        date = new Date(dateTmp);
      }
      return date.getMonth() + 1;
    };

    const dateFormat = timeStr => {
      if (!timeStr) {
        return null;
      }
      const date = new Date(timeStr);
      const day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = date.getFullYear();
      return `${year}/${month}/${day}`;
    };
    console.log('listPayments', listPayments);

    const downloadPdfBlob = (blob, fileName) => {
      const blobC = new Blob([blob], {
        type: 'application/pdf'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const handleDownloadPdfInvoice = async (month, fileName) => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadPdfInvoice(month)
        .then(data => checkSession(data));
      if (response.type === DOWNLOAD_PDF_INVOICE_SUCCESS) {
        downloadPdfBlob(response.payload, fileName);
      }
      updateLoading(false);
      updateOpenProgress(false);
    };

    const goToDonateGochiKid = () => {
      handleRedirect('/donations_shop');
    };

    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography className={classes.textTitle}>
            {isFukuoka ? '精算情報管理' : '入金情報管理'}
          </Typography>
        </div>
        {shopStripeFlag === 1 && (
          <div className={classes.viewStripeLinkDiv}>
            <Link
              href="https://dashboard.stripe.com/dashboard"
              target="_blank"
              className={classes.stripeLink}
            >
              Stripeを見る
            </Link>
          </div>
        )}
        <div className={classes.mainWrapper}>
          <Paper className={classes.mainPaper1}>
            <div className={classes.textCurrentReceivedMoneyDiv}>
              <div className={isFukuoka ? classes.textMonthHighlight : ''}>
                <div
                  className={classNames(
                    classes.textCurrentReceivedMoney,
                    !isFukuoka ? classes.fs20 : ''
                  )}
                >
                  {currentMonth || null}
                  {isFukuoka ? '月の精算金額(※1)' : '月の入金金額'}
                </div>
              </div>
              <Text className={classes.textNum}>
                {currencyFormat(sumAmountLastMonth)}
              </Text>
              <Text className={classes.textCurrency}> 円</Text>
              {isFukuoka && (
                <>
                  <div className={classes.textIntendedReceiveMoneyDiv}>
                    <div className={classes.textIntendedReceiveMoney}>
                      現時点での
                      {nextMonth || null}
                      {isFukuoka ? '月精算予定金額(※2)' : '月入金予定金額(※)'}
                    </div>
                    <span className={classes.textMoneyDiv}>
                      <Text className={classes.textSmallNum}>
                        {currencyFormat(sumAmountCurrentMonth)}
                      </Text>
                      <Text className={classes.textSmallCurrency}> 円</Text>
                    </span>
                  </div>

                  <div className={classes.textExplainDate}>
                    {isFukuoka ? (
                      <>
                        ※1
                        毎月9営業日までは前月末の振込金額を表示します。10営業日からは今月末の振込予定金額を表示します。
                        <br />
                        <br />
                        ※2
                        毎月9営業日までは今月末の振込予定金額を表示します。10営業日からは翌月末の振込予定金額を表示します。
                      </>
                    ) : (
                      <>
                        ※入金予定金額は、当該月の現在までの売上げが表示されています。
                        <br />
                        ※プレミアム金額については、月末に別途締め作業を行い送金いたします。
                        <br />
                        ※プレミアム金額については、キャンペーンによって入金タイミングが異なります。
                        <br />
                        ※正確な銀行への入金については、当該月末〆、翌5営業日以内に入金、10営業日以内に表示されます。
                        <br />
                        ※詳しくはGOCHIプラットフォーム管理システムの「入金情報管理」にて確認ください。
                        <br />
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </Paper>
          {!isFukuoka && (
            <div className={classes.paymentBalanceDiv}>
              <div style={{ fontSize: 18 }}>現在のお支払い残額</div>
              <div style={{ marginTop: 8 }}>
                <span style={{ fontSize: 48 }}>
                  {paymentBalance.toLocaleString()}
                </span>
                <span style={{ fontSize: 32 }}>円</span>
              </div>
            </div>
          )}
          <div className={classes.currentDateDiv}>
            <div className={classes.currentDate}>
              {dateFormat(new Date())}
              {` `}
              現在
            </div>
          </div>
          {!isFukuoka && (
            <div className={classes.paymentBalanceDiv}>
              <div style={{ fontSize: 18 }}>こどもごちめし支援額</div>
              <div className={classes.donateGochiKidInfo}>
                <div>
                  <div style={{ fontSize: 18 }}>支援残額</div>
                  <div style={{ marginTop: 5 }}>
                    <span style={{ fontSize: 20 }}>
                      {sumAmountGochiKidCanUse.toLocaleString()}
                    </span>
                    <span style={{ fontSize: 12 }}>円</span>
                  </div>
                </div>

                <div>
                  <div style={{ fontSize: 18 }}>支援額累計</div>
                  <div style={{ marginTop: 5 }}>
                    <span style={{ fontSize: 20 }}>
                      {sumAmountGochiKidDonate.toLocaleString()}
                    </span>
                    <span style={{ fontSize: 12 }}>円</span>
                  </div>
                </div>
              </div>
              <div className={classes.donateGochiKidDiv}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: '100%' }}
                  onClick={() => goToDonateGochiKid()}
                >
                  <span>詳細</span>
                  <ArrowForwardIosIcon className={classes.donateGochiKidIcon} />
                </Button>
              </div>
            </div>
          )}

          {listPayments.length > 0 &&
            listPayments.map(payment => {
              return (
                <>
                  <div className={classes.horizotalLine} />
                  <div className={classes.pageTitileDiv2}>
                    <Typography className={classes.textTitle2}>
                      {monthFormat(payment.month)}
                      {isFukuoka ? '月の精算金額' : '月の入金金額'}
                    </Typography>
                  </div>
                  <Paper className={classes.mainPaper} elevation={1}>
                    <div className={classes.payslipDiv}>
                      <Text className={classes.textNumBlack}>
                        {currencyFormat(
                          payment.sumAmount + payment.sumAmountStripe
                        )}
                      </Text>
                      <Text className={classes.textCurrencyBlack}> 円*</Text>
                      <div className={classes.horizotalLine} />
                      {!isFukuoka && (
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon className={classes.arrowCustom} />
                            }
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            className={classes.collapseBtn}
                          >
                            <Typography className={classes.textHeading}>
                              Stripe入金分
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Table className={classes.tableInfo}>
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    className={classes.tableInfoCellHeader}
                                  >
                                    今月売上額
                                  </TableCell>
                                  <TableCell className={classes.tableInfoCell}>
                                    {payment.sumAmountStripe === null
                                      ? 0
                                      : currencyFormat(payment.sumAmountStripe)}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </AccordionDetails>
                        </Accordion>
                      )}
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon className={classes.arrowCustom} />
                          }
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                          className={classes.collapseBtn}
                        >
                          <Typography className={classes.textHeading}>
                            {isFukuoka ? '精算明細' : '銀行口座入金分'}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Table className={classes.tableInfo}>
                            <TableBody>
                              {payment.shopPayments.length > 0 &&
                                payment.shopPayments.map(row => {
                                  return (
                                    <TableRow key={row.rowNo}>
                                      <TableCell
                                        className={classes.tableInfoCellHeader}
                                      >
                                        {row.rowLabel}
                                      </TableCell>
                                      <TableCell
                                        className={classes.tableInfoCell}
                                      >
                                        {currencyFormat(row.amount)}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              <TableRow>
                                <TableCell
                                  className={`${classes.tableInfoCellHeader} ${
                                    classes.alignRight
                                  } ${classes.tableCellBorderNone}`}
                                >
                                  銀行振込分総計
                                </TableCell>
                                <TableCell
                                  className={`${classes.tableInfoCell} ${
                                    classes.tableCellBorderNone
                                  }`}
                                >
                                  {payment.sumAmount === null
                                    ? 0
                                    : currencyFormat(payment.sumAmount)}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </AccordionDetails>
                      </Accordion>
                      {!isFukuoka && (
                        <>
                          <div className={classes.bankTransferNoteDiv}>
                            <Text className={classes.textNote}>
                              *銀行振込には所定の振込手数料がかかります。
                            </Text>
                          </div>
                          <div className={classes.supportLinkDiv}>
                            <Link
                              href="https://shop-guide.gochimeshi.com/individual/deposit/"
                              target="_blank"
                              className={classes.supportLink}
                            >
                              詳しくはこちら。
                            </Link>
                          </div>
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={
                                <ExpandMoreIcon
                                  className={classes.arrowCustom}
                                />
                              }
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                              className={classes.collapseBtn}
                            >
                              <Typography className={classes.textHeading}>
                                ごちっぷ入金分
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Table className={classes.tableInfo}>
                                <TableBody>
                                  <TableRow>
                                    <TableCell
                                      className={classes.tableInfoCellHeader}
                                    >
                                      {payment.monthStr
                                        ? moment(
                                            `${payment.monthStr}01`
                                          ).format('M')
                                        : ''}
                                      月ごちっぷ金額
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableInfoCell}
                                    >
                                      {payment.gochiTip &&
                                      payment.gochiTip.totalAmount
                                        ? currencyFormat(
                                            payment.gochiTip.totalAmount
                                          )
                                        : 0}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell
                                      className={classes.tableInfoCellHeader}
                                    >
                                      {payment.monthStr
                                        ? moment(
                                            `${payment.monthStr}01`
                                          ).format('M')
                                        : ''}
                                      月ごちっぷ数
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableInfoCell}
                                    >
                                      {payment.gochiTip &&
                                      payment.gochiTip.totalCount
                                        ? payment.gochiTip.totalCount
                                        : 0}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </AccordionDetails>
                          </Accordion>
                        </>
                      )}
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => onClickAction(payment.monthStr)}
                      >
                        {isFukuoka ? '精算明細を送る' : '入金明細を送る'}
                      </Button>
                      <div className={classes.textNoteDiv}>
                        <Text className={classes.textNote}>
                          {isFukuoka
                            ? '※登録メールアドレス宛に送ります'
                            : '※入金明細を登録メールアドレス宛に送ります'}
                        </Text>
                      </div>
                      {!isFukuoka &&
                        payment.transferDate &&
                        payment.shopPayments &&
                        payment.shopPayments.length > 0 &&
                        payment.shopPayments.find(
                          element => element.rowLabel === '銀行振込手数料'
                        ) && (
                          <>
                            <Button
                              variant="outlined"
                              color="primary"
                              className={classes.button}
                              style={{ marginTop: 31 }}
                              onClick={() =>
                                handleDownloadPdfInvoice(
                                  moment(payment.month).format('YYYYMM'),
                                  `invoice fee ${isShop &&
                                    account.shopId}${moment(
                                    payment.month
                                  ).format('YYMM')}-1.pdf`
                                )
                              }
                            >
                              請求書ダウンロード
                            </Button>
                            <div className={classes.textNoteDiv}>
                              <Text className={classes.textNote}>
                                ※銀行振込手数料分の請求書を発行しております。
                              </Text>
                            </div>
                          </>
                        )}
                    </div>
                  </Paper>
                </>
              );
            })}
        </div>

        {hasMore && (
          <div className={classes.btnViewMore}>
            <Button
              variant="contained"
              color="primary"
              size="xs"
              onClick={() => {
                loadMoreMenus();
              }}
            >
              もっと見る
            </Button>
          </div>
        )}
        <div>
          <Modal open={openNotifyPopup}>
            <NotifyPopupShop
              setOpenNotifyPopup={setOpenNotifyPopup}
              textTitle={textTitle}
              textMessage={textMessage}
            />
          </Modal>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <MenuBox account={account} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
